import { render, staticRenderFns } from "./ActivityDetails.vue?vue&type=template&id=2de4d8ba&scoped=true"
import script from "./ActivityDetails.vue?vue&type=script&lang=js"
export * from "./ActivityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de4d8ba",
  null
  
)

export default component.exports